<template>
  <div class="page-header f-r a-c">
    <div class="box"></div>
    <div class="h-right f-r f-c j-c">
      <div class="h-title">
        {{ title }}
      </div>
      <div class="h-sub-title">
        {{ subTitle }}
      </div>
    </div>
    <img v-if="pageLogo" alt="" :src="pageLogo" />
  </div>
</template>

<script setup>
defineProps({
  title: String,
  subTitle: String,
  pageLogo: String,
});
</script>

<style lang="less">
.report-page {
  .page-header {
    position: relative;

    .box {
      width: 90px;
      height: 80px;
      background: #333333;
      margin-right: 20px;
    }
    .h-title {
      height: 50px;
      font-size: 36px;

      font-weight: bold;
      color: #333333;
      line-height: 50px;
    }
    .h-sub-title {
      height: 30px;
      font-size: 22px;

      font-weight: bold;
      color: #333333;
      line-height: 30px;
      margin-top: 3px;
    }

    img {
      position: absolute;
      right: -10px;
      width: auto;
      height: 103px;
    }
  }
}
</style>
